const CLOSE_DICTIONARY_GUIDE_DESKTOP = 'close-dictionary-guide-desktop';
const DEBOUNCE_DELAY = 250;
const MAX_LENGTH_INPUT_WORD = 50;
const MAX_LENGTH_INPUT_PRONUNCIATION = 100;
const PLACEHOLDER_INPUT_NEW_WORD = 'QL4H, H2T, PSG, pronunciation';
const PLACEHOLDER_INPUT_HOW_TO_SPEAK =
  'Quốc lộ bốn hát, hoa học trò, pi-ét-x-gi, p-rô-năn-xi-ây-xừn';
const HEIGHT_ITEM = 40;
const HEIGHT_LIST = 288;
const MAX_CHAR = 100;

export {
  CLOSE_DICTIONARY_GUIDE_DESKTOP,
  DEBOUNCE_DELAY,
  MAX_LENGTH_INPUT_WORD,
  MAX_LENGTH_INPUT_PRONUNCIATION,
  PLACEHOLDER_INPUT_NEW_WORD,
  PLACEHOLDER_INPUT_HOW_TO_SPEAK,
  HEIGHT_ITEM,
  HEIGHT_LIST,
  MAX_CHAR,
};
